// let privateState = {}; // private variables for this service.
let service = {};

service.getMediaDevices = () => navigator.mediaDevices;
const mediaDevicesService = {...service};

export default mediaDevicesService;
